import { render, staticRenderFns } from "./DashCounter.vue?vue&type=template&id=4f727832&scoped=true&"
import script from "./DashCounter.vue?vue&type=script&lang=js&"
export * from "./DashCounter.vue?vue&type=script&lang=js&"
import style0 from "./DashCounter.vue?vue&type=style&index=0&id=4f727832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f727832",
  null
  
)

export default component.exports